import { render, staticRenderFns } from "./bestOffer.vue?vue&type=template&id=feb9ffe6&scoped=true&"
import script from "./bestOffer.vue?vue&type=script&lang=js&"
export * from "./bestOffer.vue?vue&type=script&lang=js&"
import style0 from "./bestOffer.vue?vue&type=style&index=0&id=feb9ffe6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb9ffe6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
